// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".send-task .ant-form-item {\n  margin-bottom: 11.2px !important;\n}\n.task-conflict {\n  height: 25px;\n}\n.spin-content {\n  padding: 20px;\n  padding-left: 70px;\n  font-weight: 600;\n}\n.send-task .ant-spin-blur {\n  opacity: 1 !important;\n}\n.send-task .ant-spin {\n  left: 0 !important;\n  top: 30px !important;\n  height: 0 !important;\n}\n.send-task .ant-spin-dot {\n  left: 50px !important;\n}\n", ""]);
// Exports
module.exports = exports;
